module.exports = "/assets/data/17d376c1d0769ca6ae718f2122520427-ST3.data.json";